/**
 * Normalizes a locale value into one of the two locales supported by the
 * API/SDKs: "en" or "fr".
 *
 * Some clients pass region-qualified locales (e.g. "fr-CA", "en-US") instead
 * of the bare "en"/"fr" values our API accepts, which results in a 422 from
 * the API. Rather than relying on every client to pass a strictly valid
 * value, we coerce anything else into the closest supported locale here.
 *
 * Rules:
 * - Values starting with "fr" (e.g. "fr-CA", "fr-somethingelse") -> "fr"
 * - Values starting with "en" (e.g. "en-CA", "en-somethingelse") -> "en"
 * - Anything else (unrecognized, empty, or missing) -> "en"
 *
 * https://locallogic.atlassian.net/browse/LL22-11775
 */
export function normalizeLocale(locale?: string | null): "en" | "fr" {
  const language = locale?.toLowerCase().split(/[-_]/)[0];

  if (language === "en" || language === "fr") {
    return language;
  }

  return "en";
}
